import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchRoleSystems } from '../../services/roleSystem.api'
import RoleSystemsHero from './RoleSystemsHero'
import { formatVolumeLabel } from './roleSystemToc'
import '../../styles/parchment-page.css'
import './RoleSystems.css'

export default function RoleSystemsIndex() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [query, setQuery] = useState('')

  useEffect(() => {
    document.title = "Shinobis' War :: Sistemas de juego"
    let cancelled = false
    ;(async () => {
      setLoading(true)
      setError(null)
      try {
        const list = await fetchRoleSystems()
        if (!cancelled) setItems(list)
      } catch (e) {
        if (!cancelled) {
          setError(e?.message || 'Error cargando sistemas')
          setItems([])
        }
      } finally {
        if (!cancelled) setLoading(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return items
    return items.filter((item) => {
      const title = (item.title || '').toLowerCase()
      const summary = (item.summary || '').toLowerCase()
      return title.includes(q) || summary.includes(q)
    })
  }, [items, query])

  return (
    <div className="page parchment-scope role-systems-page">
      <RoleSystemsHero volumeCount={items.length} />

      <div className="role-systems-page__inner">
        {items.length >= 3 ? (
          <div className="role-systems-page__search">
            <label htmlFor="role-systems-search" className="role-systems-page__search-label">
              Buscar volumen
            </label>
            <input
              id="role-systems-search"
              type="search"
              className="role-systems-page__search-input"
              placeholder="Título o resumen…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              autoComplete="off"
            />
          </div>
        ) : null}

        {loading && (
          <div className="role-systems-page__panel">
            <p className="role-systems-page__empty">Desplegando el códice…</p>
          </div>
        )}

        {!loading && error && (
          <div className="role-systems-page__panel">
            <div className="role-systems-page__error">{error}</div>
          </div>
        )}

        {!loading && !error && items.length === 0 && (
          <div className="role-systems-page__panel">
            <p className="role-systems-page__empty">
              No hay volúmenes disponibles para tu cuenta. Si crees que deberías ver documentación
              aquí, contacta con el staff.
            </p>
          </div>
        )}

        {!loading && !error && items.length > 0 && filtered.length === 0 && (
          <div className="role-systems-page__panel">
            <p className="role-systems-page__empty">Ningún volumen coincide con tu búsqueda.</p>
          </div>
        )}

        {!loading && !error && filtered.length > 0 && (
          <div className="role-systems-page__grid">
            {filtered.map((item, index) => (
              <Link
                key={item.slug}
                to={`/sistemas-de-rol/${item.slug}`}
                className="role-system-volume"
              >
                <span className="role-system-volume__glyph" aria-hidden="true">
                  制
                </span>
                <span className="role-system-volume__label">
                  {formatVolumeLabel(item.sortOrder, index)}
                </span>
                <h2 className="role-system-volume__title">{item.title}</h2>
                {item.summary ? (
                  <p className="role-system-volume__summary">{item.summary}</p>
                ) : (
                  <p className="role-system-volume__summary role-system-volume__summary--muted">
                    Abrir volumen
                  </p>
                )}
                <span className="role-system-volume__cta">
                  Leer volumen <span aria-hidden="true">→</span>
                </span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
